export const TOKEN_STORAGE_KEY = 'ONToken';
export const TOKEN_EXPIRATION_STORAGE_KEY = 'ONTokenExpiration';
export const USERNAME_STORAGE_KEY = 'ONUsername';

export const TOKEN_STORAGE_KEY_CONNECTED_AS = 'ONTokenConnectedAs';
export const USERNAME_STORAGE_KEY_CONNECTED_AS = 'ONUsernameConnectedAs';

export const API_V2_URL = '/api/v2';
export const API_V3_URL = '/api/v3';

export const PAGE_SIZE = 'expensePageSize';

// Electronic invoicing is a French-only regulation, so the related features
// are only exposed to companies located in France.
export const FRANCE_ISO_CODE = 'FRA';
